// extracted by mini-css-extract-plugin
export default {"authContainer":"Auth_authContainer__ynZh1","authCard":"Auth_authCard__LTtti","authTitle":"Auth_authTitle__OuiCO","authLinks":"Auth_authLinks__Oec+f"};